var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25.53 24.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "calendar_3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.31,12.94v-3h4v3Z",
    fill: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.09,12.94v-3h4v3Z",
    fill: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.31,19.54v-3h4v3Z",
    fill: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.09,19.54v-3h4v3Z",
    fill: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.87,12.94v-3h4v3Z",
    fill: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4,22.37H2.13V7.48H23.4ZM24.46,3.22H19.15V1.1a1.08,1.08,0,0,0-1-1.1A1.06,1.06,0,0,0,17,1V3.22H8.51V1.1A1.07,1.07,0,0,0,6.38,1V3.22H1.06A1.07,1.07,0,0,0,0,4.29V23.43A1.07,1.07,0,0,0,1.06,24.5h23.4a1.07,1.07,0,0,0,1.07-1.07V4.29A1.07,1.07,0,0,0,24.46,3.22Z",
    fill: "#7d809f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar3);
export default __webpack_public_path__ + "static/media/calendar_3.b73a9cdd514441296523414e63cf1f30.svg";
export { ForwardRef as ReactComponent };